"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src1261568677/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery/useMediaQuery"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CompletedIcon = (0, _helpers.getImageByAgent)('task-complete_white.svg');
var Breadcrumbs = function Breadcrumbs(props) {
  var currentStep = props.currentStep,
    steps = props.steps,
    subStepPercentage = props.subStepPercentage,
    handleClick = props.handleClick;
  var classes = useStyles();
  var isMobile = (0, _useMediaQuery.default)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "breadcrumbs ".concat(classes.root, " ").concat(props.className || '')
  }, /*#__PURE__*/_react.default.createElement(_core.Stepper, {
    activeStep: currentStep,
    role: "list"
  }, steps.map(function (label, index) {
    var stepProps = handleClick && index < currentStep ? {
      onClick: function onClick() {
        return handleClick(index);
      },
      style: {
        cursor: 'pointer'
      }
    } : {
      style: {
        cursor: 'default'
      }
    };
    var labelProps = {};
    var icon = attributePicker('icon', index, currentStep, subStepPercentage, isMobile, steps.length);
    var ariaLabel = attributePicker('label', index, currentStep, subStepPercentage, isMobile, steps.length);
    return /*#__PURE__*/_react.default.createElement(_core.Step, _extends({
      key: label
    }, stepProps, {
      role: "listitem",
      "aria-label": ariaLabel
    }), /*#__PURE__*/_react.default.createElement(_core.StepLabel, _extends({
      icon: icon
    }, labelProps), isMobile && index === currentStep || !isMobile ? label : ''));
  })));
};
Breadcrumbs.propTypes = {
  className: _propTypes.default.string,
  currentStep: _propTypes.default.number,
  handleClick: _propTypes.default.func,
  steps: _propTypes.default.array,
  subStepPercentage: _propTypes.default.number,
  typeOfTheme: _propTypes.default.string
};
var rootStyle = {
  '& .MuiPaper-root': {
    '& .MuiStep-root:first-child': {
      '& .MuiStepLabel-iconContainer': {
        paddingLeft: 0
      },
      paddingLeft: 0
    },
    backgroundColor: 'transparent'
  }
};
rootStyle["@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)")] = {
  '& .MuiPaper-root': {
    paddingLeft: 0,
    paddingRight: 0
  },
  '& .MuiStep-root': {
    padding: 0
  },
  '& .MuiStepLabel-active': {
    paddingRight: 8
  },
  '& .MuiStepLabel-label': {
    fontSize: 15
  },
  margin: '0 auto',
  width: 200
};
var useStyles = (0, _core.makeStyles)({
  root: rootStyle
});
var ActiveItemContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  height: 40px;\n  \n  .MuiCircularProgress-circle.MuiCircularProgress-circleDeterminate {\n    color:", ";\n  }\n  \n  &:after {\n    content: '';\n    width: 17px;\n    height: 17px;\n    border-radius: 15px;\n    background-color: ", ";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  \n  .bar {\n    box-shadow: -2px 0px 3px #00000024;\n    border-radius: 25px;\n  }\n"])), _helpers.agentDeveloperUtils.getPrimaryColor(300), _helpers.agentDeveloperUtils.getPrimaryColor(450));
var CompletedItemIconContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  position: relative;\n  img {\n    position: absolute;\n    bottom: 3px;\n    left: 4px;\n  }\n"])), _helpers.agentDeveloperUtils.getPrimaryColor(450));
var attributePicker = function attributePicker(attribute, index, currentStep, subStepPercentage, isMobile, stepsLength, typeOfTheme) {
  var answer = '';
  if (index === currentStep) {
    if (attribute === 'label') {
      answer = "\u05E9\u05DC\u05D1 \u05E0\u05D5\u05DB\u05D7\u05D9 ".concat(index, " \u05DE\u05EA\u05D5\u05DA ").concat(stepsLength);
    } else {
      answer = /*#__PURE__*/_react.default.createElement(ActiveItemIcon, {
        typeOfTheme: typeOfTheme,
        subStepPercentage: subStepPercentage
      });
    }
  } else if (index > currentStep) {
    if (attribute === 'label') {
      answer = "\u05E9\u05DC\u05D1 ".concat(index, " \u05DE\u05EA\u05D5\u05DA ").concat(stepsLength);
    } else {
      answer = /*#__PURE__*/_react.default.createElement(DisabledItemIcon, {
        isMobile: isMobile
      });
    }
  } else if (attribute === 'label') {
    answer = "\u05E9\u05DC\u05D1 \u05D4\u05D5\u05E9\u05DC\u05DD ".concat(index, " \u05DE\u05EA\u05D5\u05DA ").concat(stepsLength);
  } else {
    answer = /*#__PURE__*/_react.default.createElement(CompletedItemIcon, {
      typeOfTheme: typeOfTheme
    });
  }
  return answer;
};
var ActiveItemIcon = function ActiveItemIcon(_ref) {
  var subStepPercentage = _ref.subStepPercentage,
    typeOfTheme = _ref.typeOfTheme;
  return /*#__PURE__*/_react.default.createElement(ActiveItemContainer, {
    typeOfTheme: typeOfTheme
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    className: 'bar',
    variant: "determinate",
    value: subStepPercentage,
    "aria-label": "\u05E9\u05DC\u05D1 \u05E0\u05D5\u05DB\u05D7\u05D9",
    thickness: 12
  }));
};
ActiveItemIcon.propTypes = {
  subStepPercentage: _propTypes.default.number,
  typeOfTheme: _propTypes.default.string
};
var DisabledItemIcon = function DisabledItemIcon(_ref2) {
  var isMobile = _ref2.isMobile;
  return /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
    variant: "determinate",
    value: 100,
    thickness: 4,
    "aria-label": "\u05E9\u05DC\u05D1",
    size: isMobile ? '13px' : '16px'
  });
};
DisabledItemIcon.propTypes = {
  isMobile: _propTypes.default.bool
};
var CompletedItemIcon = function CompletedItemIcon(_ref3) {
  var typeOfTheme = _ref3.typeOfTheme;
  return /*#__PURE__*/_react.default.createElement(CompletedItemIconContainer, {
    typeOfTheme: typeOfTheme
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: CompletedIcon,
    alt: "",
    role: "presentation"
  }));
};
CompletedItemIcon.propTypes = {
  typeOfTheme: _propTypes.default.string
};
var _default = exports.default = Breadcrumbs;